const cnsPath=[
    {
    label:"Please indicated which of the following are present:",
    controlType:"checkbox group extra wide",
    options:["Progressive neurological defect", "Headache (please use 'Symptoms section' to describe features)", "Unilateral sensorineural deafness",
    "New / recent onset seizures (consider 'first fit referal",
    "Cranial nerve palsy",
    "Unexplained personality changes", "Unexplained cognitive impairement", "Unexplained behavioural changes", "Unexplained slowness"]
    },

    {
    label:"If there is any history of stroke please provide details",
    controlType:"text area",
    options:[]
    },

    {
    label:"Please detail any vascular risk factors including hypertension",
    controlType:"text area",
    options:[]
    },

    {
    label:"Please detail any neurological history (optic neuritis, head injury etc)",
    controlType:"text area",
    options:[]
    },

    ]
export default cnsPath
   